import React, { useState } from 'react';
import './EmailPopup.css';

const EmailPopup = ({ email: initialEmail, onEmailMe, onWait }) => {
  const [email, setEmail] = useState(initialEmail || '');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleEmailMe = () => {
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    setError('');
    onEmailMe(email);
  };

  return (
    <div className="email-popup-overlay">
      <div className="email-popup-card">
        <div className="email-popup-icon">📧</div>
        <h2>Analysis takes 3-5 minutes</h2>
        <p>Would you like to wait or receive the report via email?</p>
        
        <div className="email-popup-input-group">
          <label htmlFor="email-input">Email address</label>
          <input
            id="email-input"
            type="email"
            className={`email-popup-input ${error ? 'error' : ''}`}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (error) setError('');
            }}
            placeholder="you@company.com"
          />
          {error && <span className="email-popup-error">{error}</span>}
        </div>

        <div className="email-popup-buttons">
          <button 
            className="email-popup-btn email-popup-btn-primary"
            onClick={handleEmailMe}
          >
            Email me when ready
          </button>
          <button 
            className="email-popup-btn email-popup-btn-secondary"
            onClick={onWait}
          >
            Wait for report
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailPopup;

